import { User, LoginState, isLoggedInState } from "../components/portal/state";
import * as React from "react"
import * as i18next from 'i18next'
import { Action, loadingAsyncState } from "widgets-for-react";
import { State, ExtraUserInfo } from "./portal_client";
import { getCharacteristics } from "./portal_utils/api"
import * as Immutable from "immutable"
import { RadioCheckboxOptions } from "./custom_components"
import { CharacteristicValue, Characteristic as CharacteristicType } from "./portal/types"

export type CharacteristicProps = {
  user: () => User<ExtraUserInfo>,
  setState: (_: Action<LoginState<State, ExtraUserInfo>>) => void,
  state: LoginState<State, ExtraUserInfo>,
  label: string,
  helpText?: string,
  component: JSX.Element,
  showSummary: boolean
  characteristicId: string,
  characteristicValues: Immutable.List<RadioCheckboxOptions>,
  range?: string
}

type CharacteristicState = {
  isHelpTextVisible: boolean
}

export class Characteristic extends React.Component<CharacteristicProps, CharacteristicState>  {
  constructor(props: CharacteristicProps, context: any) {
    super(props, context)
    this.state = { isHelpTextVisible: false }
  }

  toggleHelptext = () => {
    this.setState((s) => ({
      ...this.state,
      isHelpTextVisible: !s.isHelpTextVisible
    }));
  };

  render() {
    let { productConfigurations, selectedProductConfiguration } = this.props.state.appState;
    let { characteristicId } = this.props;
    let selectedCharacteristic = productConfigurations.get(selectedProductConfiguration).CharacteristicValues.find(ch => ch.CharacteristicId === characteristicId)
    let selectedValueId = !!selectedCharacteristic ? selectedCharacteristic.CharacteristicValueId : null;
    let displayValue = this.getDisplayValue(selectedValueId, selectedCharacteristic ? selectedCharacteristic.CharacteristicValueId : null)
    return (
      <>
        <header className="expand__header">
          <h4 className={`title--s expand__title ${(characteristicId !== productConfigurations.get(selectedProductConfiguration).SelectedCharacteristic && displayValue == "-") ? "expand__title--disabled" : ""}`}>
            {this.props.label}
          </h4>
          {this.props.showSummary && (characteristicId !== productConfigurations.get(selectedProductConfiguration).SelectedCharacteristic && (displayValue !== "-"  && displayValue !== 0 || displayValue !== 0)) && (
            <div className="expand__summary">
              <div className="expand__answer truncate-ellipsis">
                <span>{displayValue}</span>
              </div>
              { this.props.characteristicValues.count() != 1 &&
              <button
                type="button"
                className="expand__button--edit button--icon"
                onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                  document.documentElement.classList.add('alert--toggled');
                  this.props.setState(s => {
                    if (isLoggedInState(s)) {
                      return ({
                        ...s,
                        appState: {
                          ...s.appState,
                          editCharateristicId: characteristicId,
                          isAlertTypeOpen: {
                            ...s.appState.isAlertTypeOpen,
                            editCharacteristic: !s.appState.isAlertTypeOpen.editCharacteristic
                          }
                        }
                      })
                    }
                  })
                }}
              >
                <span className="sr-text">{i18next.t('quotation_request:product.clickables.edit_characteristic')}</span>
                <svg className="button__icon" width="18px" height="20px" aria-hidden="true">
                  <use xlinkHref="#icon--edit" />
                </svg>
              </button>}
            </div>
          )}
        </header>

        <div
          className="expand__content"
          hidden={!(characteristicId === productConfigurations.get(selectedProductConfiguration).SelectedCharacteristic)}
        >
          {this.props.helpText &&
            <>
              <p className="expand__text section__text" hidden={!this.state.isHelpTextVisible} id={`a11y-help-text-${this.props.characteristicId}`}>{this.props.helpText}</p>
              <button
                type="button"
                className="expand__button--info"
                aria-controls={`a11y-help-text-${this.props.characteristicId}`}
                aria-expanded={this.state.isHelpTextVisible}
                onClick={(e) => this.toggleHelptext()}
              >
                <span id="a11y-help-text-toggle" className="sr-text">{i18next.t('quotation_request:product.clickables.toggle_helptext')}</span>
                <svg className="expand__icon expand__icon--open" width="20px" height="20px" aria-hidden="true">
                  <use xlinkHref="#icon--info" />
                </svg>
                <svg className="expand__icon expand__icon--close" width="10px" height="10px" aria-hidden="true">
                  <use xlinkHref="#icon--cross" />
                </svg>
              </button>
            </>
          }

          <div className="expand__selector">
            {this.props.component}
            
            {(this.props.range != null && this.valueNotWithinRange(this.props.range, selectedCharacteristic ? selectedCharacteristic.CharacteristicValueId : null)) &&
              <div className="form__description form__error" role="alert">
                <p>{i18next.t('quotation_request:product.range_explanation')} {this.props.range}</p>
              </div>}
          </div>

          <button
            type="button"
            className="expand__button--navigation button button--primary"
            disabled={displayValue == "-" || (this.props.range != null && this.valueNotWithinRange(this.props.range, selectedCharacteristic ? selectedCharacteristic.CharacteristicValueId : null))}
            onClick={() => {
              let characteristics = loadingAsyncState(() =>
                getCharacteristics(
                  this.props.state.appState.language_code,
                  isLoggedInState(this.props.state) &&
                  productConfigurations.get(selectedProductConfiguration) ?
                  productConfigurations.get(selectedProductConfiguration).ProductId : "",
                  isLoggedInState(this.props.state) &&
                  productConfigurations.get(selectedProductConfiguration).CharacteristicValues).then(result => {
                    return result
                  }))


              this.props.setState(s => {
                if (isLoggedInState(s)) {
                  let prodconfigs = s.appState.productConfigurations
                  // Characteristics contains current Characteristics so we could compare this with characteristics
                  // to see what has changed. For now we only check if already entered values are still valid and
                  // if not clear them
                  prodconfigs.get(s.appState.selectedProductConfiguration).CharacteristicArray = characteristics;
                  return ({ ...s, appState: { ...s.appState, productConfigurations: prodconfigs } })
                }
              })
            }}
          >
            {i18next.t('quotation_request:product.clickables.next_question')}
          </button>
        </div>
      </>
    )
  }
  getDisplayValue(selectedValueId: string, textValue?: string) {
    if (this.props.characteristicValues.count() == 1) {
      return this.props.characteristicValues.first().label
    }
    if (textValue) {
      return textValue
    }
    let { productConfigurations, selectedProductConfiguration } = this.props.state.appState;
    let productConfiguration =  productConfigurations.get(selectedProductConfiguration)
    if (this.props.characteristicId == "Count") {
      if (productConfiguration.Count > 0)
        return productConfiguration.Count
      else
        return "-"
    }
    if (this.props.characteristicId == "ProductId") {
      if (this.props.characteristicValues.find(value => value.value == productConfiguration.ProductId))
        return this.props.characteristicValues.find(value => value.value == productConfiguration.ProductId).label
      else
        return "-"
    }
    if (selectedValueId) {
       if (productConfigurations.get(selectedProductConfiguration).CharacteristicArray.kind === "loaded"
       && this.props.characteristicValues.find(value => value.value == selectedValueId))
         return this.props.characteristicValues.find(value => value.value == selectedValueId).label
       else return "-"
     } else {
       return "-"
     }
   }

   validateCharacteristicValues(values: CharacteristicValue[], characteristics: CharacteristicType[]){
     // only return characteristic values that are still valid options
     return values.filter(value => characteristics.find(ch => ch.Id == value.CharacteristicId) ? characteristics.find(ch => ch.Id == value.CharacteristicId).ValueOptions.find(option => option.ValueId == value.CharacteristicValueId) : false)
   }

  valueNotWithinRange(range: string, value: string) {
    if (value == null) {
      return false
    }
    let rangevalues = range[0].split("-")
    if (rangevalues[0] == null || rangevalues[1] == null) {
      return false
    }
    let min = Number(rangevalues[0].replace(",", "").trim())
    let max = Number(rangevalues[1].replace(",", "").trim())
    let valuenumber = Number(value.replace(",", "").trim())
    if (min <= valuenumber && max >= valuenumber ) {
      return false
    }
    return true
  }
}

export const CharacteristicElement =
  (
    user: () => User<ExtraUserInfo>,
    setState: (_: Action<LoginState<State, ExtraUserInfo>>) => void,
    state: LoginState<State, ExtraUserInfo>,
    label: string,
    component: JSX.Element,
    characteristicId: string,
    characteristicValues: Immutable.List<RadioCheckboxOptions>
  ): JSX.Element => <Characteristic showSummary={true} user={user} setState={setState} state={state} component={component} label={label} characteristicId={characteristicId} characteristicValues={characteristicValues}/>
